import React, { useState, useEffect } from 'react';
import './ModernBlocks.css';

const ImageSliderBlock = ({ data }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  // Auto-slide functionality
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % data.images.length);
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(interval);
  }, [data.images.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % data.images.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + data.images.length) % data.images.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <section className="image-slider-section">
      <div className="image-slider-container">
        <div className="image-slider">
          {data.images.map((image, index) => (
            <div
              key={index}
              className={`image-slide ${index === currentSlide ? 'active' : ''}`}
              style={{
                backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${image.url})`
              }}
            >
              <div className="slide-content">
                <h2 className="slide-title">{image.title || 'Welcome'}</h2>
                <p className="slide-description">{image.description || 'Discover amazing possibilities'}</p>
                {image.button && (
                  <button className="slide-button" onClick={() => window.location.href = image.button.link}>
                    {image.button.text}
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Navigation Arrows */}
        <button className="slider-nav slider-nav-prev" onClick={prevSlide}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M15 18l-6-6 6-6"/>
          </svg>
        </button>
        <button className="slider-nav slider-nav-next" onClick={nextSlide}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M9 18l6-6-6-6"/>
          </svg>
        </button>

        {/* Slide Indicators */}
        <div className="slider-indicators">
          {data.images.map((_, index) => (
            <button
              key={index}
              className={`slider-indicator ${index === currentSlide ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
            />
          ))}
        </div>

        {/* Slide Counter */}
        <div className="slider-counter">
          <span className="current-slide">{currentSlide + 1}</span>
          <span className="total-slides">/ {data.images.length}</span>
        </div>
      </div>
    </section>
  );
};

export default ImageSliderBlock; 